import { graphql, useStaticQuery } from "gatsby";
import { useMemo } from "react";

const useBlogPosts = () => {
	const { allPrismicBlogArticle } = useStaticQuery(graphql`
		{
			allPrismicBlogArticle {
				nodes {
					uid
					last_publication_date
					data {
						blurb {
							text
						}
						category {
							document {
								... on PrismicBlogCategory {
									id
									data {
										category_name {
											text
										}
									}
								}
							}
						}
						feature_image {
							url
							dimensions {
								height
								width
							}
						}
						pushed_date
						title {
							text
						}
						content {
							text
							html
						}
						time_to_read
					}
				}
			}
		}
	`);

	return useMemo(() => {
		return allPrismicBlogArticle.nodes.map((a) => ({
			slug: a.uid,
			title: a.data.title.text,
			blurb: a.data.blurb.text,
			content: a.data.content,
			category: a.data.category.document.data.category_name.text,
			published: a.data.pushed_date || a.last_publication_date,
			time_to_read: a.data.time_to_read,
			feature_image: {
				url: a.data.feature_image.url,
				width: a.data.feature_image.dimensions.width,
				height: a.data.feature_image.dimensions.height,
			},
		}));
	}, [allPrismicBlogArticle]);
};

export default useBlogPosts;
